import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllQa } from "../../redux/services/qaSlice";
import Table from "../../common/Table";
import { convertUtcToIst } from "../../common/TimeUtils";
import moment from "moment-timezone";
import { useNavigate } from "react-router-dom";
import { exportToTablePDF } from "../../common/PdfFormat";

const QA = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const qaData = useSelector((state) => state.qa.qaData);
  const [page, setPage] = useState(0);
  const [activeTab, setActiveTab] = useState("all");
  const limitOptions = [
    { value: 10, label: 10 },
    { value: 30, label: 30 },
    { value: 50, label: 50 },
    { value: 100, label: 100 },
  ];
  const [pageLimit, setPageLimit] = useState(limitOptions[0]?.value);
  const getAllQaApi = useCallback(async () => {
    try {
      const filterValue =
        activeTab === "upcoming"
          ? "upcoming,ongoing"
          : activeTab === "past"
          ? "completed"
          : activeTab;

      const params = {
        page: page + 1,
        limit: pageLimit,
      };

      if (activeTab !== "all") {
        params.contestFilter = filterValue;
      }

      await dispatch(getAllQa(params));
    } catch (error) {}
  }, [dispatch, page, pageLimit, activeTab]);

  useEffect(() => {
    getAllQaApi();
  }, [getAllQaApi]);
  const columns = [
    {
      label: "S/N",
      key: "index",
      render: (_, __, index) => page * pageLimit + index + 1,
    },
    {
      label: "Result",
      key: "status",
      render: (_, row) => (
        <button
          className="w-[100px] h-9 bg-[#124699] font-semibold rounded-md text-white cursor-pointer"
          onClick={() => {
            navigate(`/view-result?qaId=${row._id}&contestId=${row.contestId._id}`);
          }}
        >
          View
        </button>
      ),
    },
    {
      label: "Contest Name",
      key: "contestName",
      render: (_, row) => row?.contestId?.name || "-",
    },
    {
      label: "Start Date",
      key: "start-date",
      render: (_, row) =>
        row.contestId?.startDate
          ? moment(convertUtcToIst(row.contestId?.startDate)).format(
              "DD-MM-YYYY hh:mm A"
            )
          : "-",
    },
    {
      label: "End Date",
      key: "end-date",
      render: (_, row) =>
        row.contestId?.endDate
          ? moment(convertUtcToIst(row.contestId?.endDate)).format(
              "DD-MM-YYYY hh:mm A"
            )
          : "-",
    },
    {
      label: "Subject",
      key: "subject",
      render: (_, row) => row?.subjectId?.name || "-",
    },
    {
      label: "F.S/T.S",
      key: "f.s/t.s",
      render: (_, row) =>
        row?.contestId?.filledSpots || row?.contestId?.totalSpots
          ? row?.contestId?.filledSpots + "/" + row?.contestId?.totalSpots
          : "-",
    },
    {
      label: "Fees",
      key: "fees",
      render: (_, row) => row?.contestId?.fees || "-",
    },
    {
      label: "Price Pool",
      key: "pricePool",
      render: (_, row) => row?.contestId?.pricePool || "-",
    },
  ];
  const exportToPDF = () => {
    const headersConfig = [
      {
        label: "S/N",
        key: "index",
        render: (_, __, index) => page * pageLimit + index + 1,
      },
      {
        label: "Contest Name",
        key: "contestName",
        render: (_, row) => row?.contestId?.name || "-",
      },
      {
        label: "Start Date",
        key: "start-date",
        render: (_, row) =>
          row.contestId?.startDate
            ? moment(convertUtcToIst(row.contestId?.startDate)).format(
                "DD-MM-YYYY hh:mm A"
              )
            : "-",
      },
      {
        label: "End Date",
        key: "end-date",
        render: (_, row) =>
          row.contestId?.endDate
            ? moment(convertUtcToIst(row.contestId?.endDate)).format(
                "DD-MM-YYYY hh:mm A"
              )
            : "-",
      },
      {
        label: "Subject",
        key: "subject",
        render: (_, row) => row?.subjectId?.name || "-",
      },
      {
        label: "F.S/T.S",
        key: "f.s/t.s",
        render: (_, row) =>
          row?.contestId?.filledSpots || row?.contestId?.totalSpots
            ? row?.contestId?.filledSpots + "/" + row?.contestId?.totalSpots
            : "-",
      },
      {
        label: "Fees",
        key: "fees",
        render: (_, row) => row?.contestId?.fees || "-",
      },
      {
        label: "Price Pool",
        key: "pricePool",
        render: (_, row) => row?.contestId?.pricePool || "-",
      },
    ]
    const data = qaData?.contest_type_data || [];
    exportToTablePDF({
      tableName: "QA Data",
      data,
      headersConfig,
      pdfName: "qa_data.pdf",
    });
  };
  return (
    <div className="mx-auto bg-white shadow-lg rounded-xl p-6">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        QA Management
      </h2>
      <div className="flex justify-between items-center">
      <div className="flex space-x-4 border-b pb-2">
        {["all", "upcoming", "past"].map((tab) => (
          <button
            key={tab}
            onClick={() => setActiveTab(tab)}
            className={`w-[150px] h-[50px] flex justify-center font-semibold text-lg items-center 
        rounded-md mt-3 transition duration-300 ${
          activeTab === tab
            ? "bg-[#124699] text-white"
            : "bg-gray-200 text-gray-700 hover:bg-gray-300"
        }`}
          >
            {tab.charAt(0).toUpperCase() + tab.slice(1)}
          </button>
        ))}
      </div>
      <button className="bg-[#124699] text-white px-4 py-2 rounded-lg font-semibold h-fit" onClick={exportToPDF}>Export PDF</button>
      </div>
      <Table
        title={`${activeTab} Contest`}
        columns={columns}
        data={qaData?.contest_type_data}
        pageCount={qaData?.state?.page_limit}
        onPageChange={(selectedItem) => setPage(selectedItem.selected)}
        pageLimitOptions={limitOptions}
        selectedPageLimit={pageLimit}
        onPageLimitChange={setPageLimit}
        
      />
    </div>
  );
};

export default QA;
